import React from 'react';

import { ButtonProps } from 'antd/es/button/button';

import ChevronRight from 'common/Icons/ChevronRight';

import GradientBorderButton from './GradientBorderButton';

const DetailsButton = (props: ButtonProps) => (
  <GradientBorderButton size="small" {...props}>
    Details <ChevronRight fill="var(--competitor-purple)" width={16} height={16} />
  </GradientBorderButton>
);

export default DetailsButton;
